import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Crown, Award } from 'lucide-react';
import { useTranslation } from 'react-i18next'; // Importo useTranslation

const SubscriptionBadge = () => {
  const { currentUser, getAuthenticatedApi } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation(); // Uso hook useTranslation
  
  useEffect(() => {
    if (!currentUser) return;
    
    const fetchSubscription = async () => {
      try {
        setLoading(true);
        const api = getAuthenticatedApi();
        
        const response = await api.get('/subscription_api.php?action=current_subscription');
        
        if (response.data.success) {
          setSubscription(response.data.subscription);
        }
      } catch (error) {
        console.error(t('standaloneDashboard.errors.subscriptionFetch'), error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchSubscription();
  }, [currentUser, getAuthenticatedApi, t]); // Aggiungo t alle dipendenze
  
  // Rimosso: subscription non più disponibile per standalone
  return null;
  
  if (loading || !subscription) return null;
  
  // Se è piano gratuito, mostriamo solo un link sottile
  if (subscription.price === 0) {
    return (
      <Link 
        to="/standalone/subscription" 
        className="text-xs text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 flex items-center"
      >
        <Crown className="h-3 w-3 mr-1" />
        {t('subscription.upgradeToBase')}
      </Link>
    );
  }
  
  // Se è un piano a pagamento, mostriamo un badge più evidente
  return (
    <Link
      to="/standalone/subscription"
      className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:from-indigo-700 hover:to-purple-700 transition"
    >
      <Award className="h-3 w-3 mr-1" />
      {t('subscription.plan')} {subscription.plan_name}
    </Link>
  );
};

export default SubscriptionBadge;